import React from "react"; // eslint-disable-line
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _actions from "../../actions";
import MenuArrow from "../../components/svg/MenuArrow";
import MenuItem from "../../components/common/MenuItem";
import i18n from "../../i18n";
import AppSettings from "../../components/svg/AppSettings";
import Modules from "../../components/svg/Modules";
import Design from "../../components/svg/Design";
import Status from "../../components/svg/Status";
import LeftArrowCircle from "../../components/svg/LeftArrowCircle";
import FilesIcon from "../../components/svg/FilesIcon";
import Pages from "../../components/svg/Pages";
import appStateProvider from "../../utilities/appStateProvider";

class Sidecar extends React.Component {
  constructor(props) {
    super(props);

    this.props = props;

    this.toggleMenuState = this.toggleMenuState.bind(this);
    this.toggleActiveState = this.toggleActiveState.bind(this);
    this.formBuilder = this.createRef;
  }

  componentDidMount() {
    this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
    this.props.actions.getProjectVersionMenuItems(this.props.match.params.projectId);
    if (this.props.location) {
      if (this.props.location.pathname.indexOf("modules") > -1) {
        this.props.actions.setMenuOpenSection("modules");
      } else if (this.props.location.pathname.indexOf("design") > -1) {
        this.props.actions.setMenuOpenSection("design");
      } else if (
        this.props.location.pathname.indexOf("submission") > -1 ||
        this.props.location.pathname.indexOf("status") > -1 ||
        this.props.location.pathname.indexOf("pages") > -1
      ) {
        this.props.actions.setMenuOpenSection("");
      } else {
        this.props.actions.setMenuOpenSection("appSettings");
      }
    }
  }

  componentDidUpdate() {
    if (
      this.props.autoClose > 1100 &&
      this.props.autoClose < 1280 &&
      this.props.previewOn &&
      this.props.sidecar.show
    ) {
      this.toggleMenuState();
    }
    if (this.props.autoClose < 1101 && this.props.sidecar.show) {
      this.toggleMenuState();
    }
  }

  checkFmsStandalone = () => {
    const appData = appStateProvider();
    return appData.isStandalone() ? "mn-forms-visible" : "mn-forms-hidden";
  };

  toggleMenuState() {
    this.props.actions.toggleMenuShown(this.props.sidecar.show);
  }

  toggleActiveState(name) {
    const hide = this.props.sidecar.openSection === name;
    this.props.actions.setMenuOpenSection(hide ? "" : name);
  }

  render() {
    let baseVersionLink = "";
    if (this.props && this.props.match && this.props.match.params) {
      baseVersionLink = `/projects/${this.props.match.params.projectId}`;
    }
    const isUnity = localStorage.getItem("IsUnity");
   
    const isTrial = localStorage.getItem('IsTrial');

    let sidecarClass = this.props.sidecar.show ? "active" : "hidden";
    sidecarClass = `${sidecarClass} ${
      this.props.sidecar.showMobile ? "mobile-active" : "mobile-hidden"
    }`;

    let viewForms = this.checkFmsStandalone();
    
    return (
      <div id="sidecar" className={sidecarClass}>
        <ul className="sidecar-nav">
          <li
            className={`mn-app-settings has-children ${
              this.props.sidecar.openSection === "appSettings" ? "current" : ""
            }`}
          >
            <div
              className={`svg-image-link ${
                this.props.sidecar.openSection === "appSettings" ? "active" : ""
              }`}
            >
              <Link
                to={{
                  pathname: `${baseVersionLink}/general-info`,
                }}
              >
                <span className="menu-icon menu-appsettings">
                  <AppSettings />
                </span>
                <span className="menu-title">
                  {i18n.t("menu.app-settings")}
                </span>
              </Link>
              {/* eslint-disable-next-line */}
              <span
                className="menu-toggle"
                onClick={(fn) => {
                  this.toggleActiveState("appSettings");
                }}
              >
                <MenuArrow />
              </span>
            </div>
            <ul
              className={`sidecar-nav-secondary ${
                this.props.sidecar.openSection === "appSettings" ? "active" : ""
              }`}
            >
              <li
                className={`sn-secondary__parent mn-app-settings ${
                  this.props.sidecar.openSection === "appSettings"
                    ? "current"
                    : ""
                }`}
              >
                {i18n.t("menu.app-settings")}
              </li>
              <MenuItem
                baseVersionLink={baseVersionLink}
                currentMenuItem={this.props.menuItem}
                name={i18n.t("menu.general-info")}
                link="general-info"
                className="sn-general-info"
                moduleName="GeneralInfo"
              />
              <MenuItem
                baseVersionLink={baseVersionLink}
                currentMenuItem={this.props.menuItem}
                name={i18n.t("menu.logo")}
                link="logos"
                className="sn-logo"
                moduleName="Logo"
              />
              {this.props.flags.results &&
                (this.props.flags.results?.liveStreaming ||
                  this.props.flags.results?.chMSIntegration ||
                  this.props.flags.results?.shareFaithDevotionals) && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.integrations")}
                    link="integrations"
                    className="sn-integrations"
                    moduleName="Integrations"
                  />
                )}
            </ul>
          </li>
          <li
            className={`mn-modules has-children ${
              this.props.menuSection === "Modules" ? "current" : ""
            }`}
          >
            <div
              className={
                this.props.sidecar.openSection === "modules"
                  ? "active expand"
                  : ""
              }
            >
              <Link
                to={{
                  pathname: `${baseVersionLink}/modules/enable-modules`,
                }}
              >
                <span className="menu-icon menu-modules">
                  <Modules />
                </span>
                <span className="menu-title">{i18n.t("menu.modules")}</span>
              </Link>
              {/* eslint-disable-next-line */}
              <span
                className="menu-toggle"
                onClick={(fn) => {
                  this.toggleActiveState("modules");
                }}
              >
                <MenuArrow />
              </span>
            </div>
            <ul
              className={`sidecar-nav-secondary ${
                this.props.sidecar.openSection === "modules" ? "active" : ""
              }`}
            >
              <li
                className={`sn-secondary__parent mn-modules ${
                  this.props.menuSection === "Modules" ? "current" : ""
                }`}
              >
                {i18n.t("menu.modules")}
              </li>
              <MenuItem
                baseVersionLink={baseVersionLink}
                currentMenuItem={this.props.menuItem}
                name={i18n.t("menu.enable")}
                link="modules/enable-modules"
                className="sn-enable-modules"
                moduleName="EnableModules"
              />
              {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(3) && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.giving")}
                    link="modules/giving"
                    className="sn-giving"
                    moduleName="GivingModule"
                  />
                )}
              {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(2) && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.sermons")}
                    link="modules/sermons"
                    className="sn-sermons"
                    moduleName="SermonsModule"
                  />
                )}
              {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(4) && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.events")}
                    link="modules/events"
                    className="sn-events"
                    moduleName="EventsModule"
                  />
                )}
              {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(1) && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.discover")}
                    link="modules/discover/configure"
                    className="sn-discover"
                    moduleName="DiscoverModule"
                  />
                )}
              {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(10) &&
                this.props.flags.results &&
                this.props.flags.results?.calendar && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.calendar")}
                    link="modules/calendar"
                    className="sn-calendar"
                    moduleName="CalendarModule"
                  />
                )}
              {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(5) && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.contact")}
                    link="modules/contact"
                    className="sn-contact"
                    moduleName="ContactModule"
                  />
                )}
              {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(9) &&
                this.props.flags.results &&
                this.props.flags.results?.scPeople &&
                this.props.flags.results?.chMSIntegration && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.people")}
                    link="modules/people"
                    className="sn-people"
                    moduleName="PeopleModule"
                  />
                )}
              {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(11) &&
                this.props.flags.results &&
                this.props.flags.results?.scGroups &&
                this.props.flags.results?.chMSIntegration && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.groups")}
                    link="modules/groups"
                    className="sn-groups"
                    moduleName="GroupsModule"
                  />
                )}
              {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(13) && isUnity && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("servicePlanning")}
                    link="modules/service-planning"
                    className="sn-service-planning"
                    moduleName="ServicePlanningModule"
                  />
                )}
                {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(14) &&
                this.props.flags.results &&
                this.props.flags.results?.studioC &&
                this.props.flags.results?.chMSIntegration && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.studioc")}
                    link="modules/studioc"
                    className="sn-studioc"
                    moduleName="StudioCModule"
                  />
                )}
                {this.props.sidecar.modules &&
                this.props.sidecar.modules.includes(15) &&
                this.props.flags.results &&
                this.props.flags.results?.attendance &&
                this.props.flags.results?.chMSIntegration && (
                  <MenuItem
                    baseVersionLink={baseVersionLink}
                    currentMenuItem={this.props.menuItem}
                    name={i18n.t("menu.attendance")}
                    link="modules/attendance"
                    className="sn-attendance"
                    moduleName="AttendanceModule"
                  />
                )}
            </ul>
          </li>
          {this.props.flags.results &&
            this.props.flags.results?.customContent &&
            this.props.flags.results?.customContentPages && (
              <li
                className={`mn-pages ${
                  this.props.menuSection === "Pages" ? "current" : ""
                }`}
              >
                <div>
                  <Link to={{ pathname: `${baseVersionLink}/pages/pages` }}>
                    <span className="menu-icon">
                      <Pages />
                    </span>
                    <span className="menu-title">Pages</span>
                    <span className="menu-toggle hide-me" />
                    {/* eslint-disable-next-line */}
                  </Link>
                </div>
              </li>
            )}
          <li
            className={`mn-design has-children ${
              this.props.menuSection === "Design" ? "current" : ""
            }`}
          >
            <div
              className={
                this.props.sidecar.openSection === "design"
                  ? "active expand"
                  : ""
              }
            >
              <Link
                to={{
                  pathname: `${baseVersionLink}/design/menus`,
                }}
              >
                <span className="menu-icon menu-design">
                  <Design />
                </span>
                <span className="menu-title">{i18n.t("menu.design")}</span>
              </Link>
              {/* eslint-disable-next-line */}
              <span
                className="menu-toggle"
                onClick={(fn) => {
                  this.toggleActiveState("design");
                }}
              >
                <MenuArrow />
              </span>
            </div>
            <ul
              className={`sidecar-nav-secondary ${
                this.props.sidecar.openSection === "design" ? "active" : ""
              }`}
            >
              <li className="sn-secondary__parent mn-design">
                {i18n.t("menu.design")}
              </li>
              <MenuItem
                baseVersionLink={baseVersionLink}
                currentMenuItem={this.props.menuItem}
                name={i18n.t("menu.menu")}
                link="design/menus"
                className="sn-menus"
                moduleName="Menu"
              />
              <MenuItem
                baseVersionLink={baseVersionLink}
                currentMenuItem={this.props.menuItem}
                name={i18n.t("menu.colors")}
                link="design/colors"
                className="sn-colors"
                moduleName="Colors"
              />
            </ul>
          </li>
          <li
            className={`${viewForms} ${
              this.props.menuSection === "Forms" ? "current" : ""
            }`}
          >
            <div>
              <Link to={{ pathname: `${baseVersionLink}/forms/home` }}>
                <span className="menu-icon">
                  <FilesIcon />
                </span>
                <span className="menu-title">Forms</span>
                <span className="menu-toggle hide-me" />
                {/* eslint-disable-next-line */}
              </Link>
            </div>
          </li>
          {!isTrial
          &&
          <li
            className={`mn-status ${
              this.props.menuSection === "Status" ? "current" : ""
            }`}
          >
            <div>
              <Link to={{ pathname: `${baseVersionLink}/submission/results` }}>
                <span className="menu-icon">
                  <Status />
                </span>
                <span className="menu-title">{i18n.t("menu.status")}</span>
                <span className="menu-toggle hide-me" />
              </Link>
            </div>
          </li>
          }
        </ul>
        <div className="sidecar-bottom">
          {/* eslint-disable-next-line */}
          <a
            id="sidecar-launcher"
            className="active"
            onClick={this.toggleMenuState}
          >
            <span className="icon">
              <LeftArrowCircle />
            </span>
            <span className="title">{i18n.t("menu.collapse")}</span>
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(_actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidecar);
